import React from 'react';

import {
	EXTERNAL_LINK_CLINIPAM,
	CHAT_ROOMS_CLINIPAM,
	PRODUCT_CODE,
	PRODUCT_NAME,
	ProductEnum,
	PRODUCT_FOOTER_NAME,
	PRODUCT_LINK_ANDROID_STORE,
	PRODUCT_LINK_IOS_STORE,
} from 'presentation/constants';
import {ClinipamLogo, ClinipamIcon, ClinipamAns} from 'presentation/components/Logos';
import {ClinipamAppIcon} from 'presentation/components/Logos/Clinipam/ClinipamAppIcon';
import {AnsLogoProps, ProductIconProps, ProductLogoProps} from '../types';
import {useThemeStore} from 'presentation/store/useThemeStore';

const theme = useThemeStore.getState().theme;

export const clinipamData = {
	productLogo: ({invertColor, nameColor, ...props}: ProductLogoProps) => (
		<ClinipamLogo
			nameColor={nameColor || (invertColor ? theme.brand.primary.white : undefined)}
			{...props}
		/>
	),

	productIcon: ({color, invertColor, ...props}: ProductIconProps) => (
		<ClinipamIcon
			color={color || (invertColor ? theme.brand.primary.white : undefined)}
			{...props}
		/>
	),
	productAppIcon: (props: ProductIconProps) => <ClinipamAppIcon {...props} />,
	ansLogo: (props?: AnsLogoProps) => <ClinipamAns {...props} />,
	product: ProductEnum.CLINIPAM,
	productCode: PRODUCT_CODE.clinipam,
	productName: PRODUCT_NAME.clinipam,
	footerProductName: PRODUCT_FOOTER_NAME.clinipam,
	links: EXTERNAL_LINK_CLINIPAM,
	chatRoom: CHAT_ROOMS_CLINIPAM,
	iosStoreLink: PRODUCT_LINK_IOS_STORE.clinipam,
	androidStoreLink: PRODUCT_LINK_ANDROID_STORE.clinipam,
};
